const emptyFunction = () => { /* empty */ };

export { emptyFunction };
